import styled from '@emotion/styled';
import { useIsMobile } from '@hooks/responsive/useIsMobile';

// components
import TextArea from '@components/_atoms/TextArea';
import Typography from '@components/_atoms/Typography';

// constants
import { TypoVariant } from '@constants/atoms';
import { primary } from '@styles/Colors';

type Props = {
  readonly title?: string;
  readonly textarea?: TextAreaType;
};

type TextAreaType = {
  readonly height?: string;
  readonly name?: string;
  readonly value?: string;
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const Layout = styled.div`
  display: grid;
  row-gap: 8px;
`;

export default function TextAreaBox({ title, textarea }: Props) {
  const isMobile = useIsMobile();

  return (
    <Layout>
      <>
        {title && (
          <Typography variant={isMobile ? TypoVariant.SH4 : TypoVariant.SH3} color={primary.gray}>
            {title}
          </Typography>
        )}
      </>
      <>
        <TextArea
          height={textarea?.height}
          name={textarea?.name}
          value={textarea?.value}
          placeholder={textarea?.placeholder}
          disabled={textarea?.disabled}
          onChange={textarea?.onChange}
        />
      </>
    </Layout>
  );
}
